import React from 'react';
import { HeroCanvas } from './HeroCanvas';
import { SetupArt } from './illustrations';

/**
 * The /pricing hero.
 *
 * Same canvas as home and /features, carrying this page's own words — the
 * copy is the old PageHero's, unchanged. What differs page to page is the
 * object on the panel: home has the phone, /features the dashboard, and
 * this one the savings scene, so the three open on the same plane without
 * opening on the same picture.
 *
 * No action button here on purpose. The price card directly below is one
 * screen down and carries the only CTA this page needs; a second one in the
 * hero would compete with it and send the same click somewhere else.
 */
const PricingHero = () => (
  <HeroCanvas>
    <div className="grid items-center gap-14 lg:grid-cols-[1.15fr_0.85fr] lg:gap-10">
      <div>
        <span className="eyebrow accent-3 animate-fade-up">
          <span className="spark-mark" aria-hidden="true" />
          Beta launch
        </span>

        <h1 className="display-heading mt-6 animate-fade-up" style={{ animationDelay: '70ms' }}>
          <span className="display-solid block">Free for your</span>
          <span className="display-accent block">first month</span>
        </h1>

        <p
          className="mt-6 max-w-xl text-lede leading-relaxed text-content-muted animate-fade-up"
          style={{ animationDelay: '140ms' }}
        >
          WASLX is in beta. No tiers, no paywalls, no trial limits — the full platform, completely
          free for 30 days.
        </p>
      </div>

      {/* SetupArt, not SavingsArt. The savings scene is three descending grey
          bars under a falling dashed line — beside "Free for your first
          month" that reads as decline, and it is the palest drawing in the
          set. The clock with its run of green ticks says "thirty days,
          nothing owed", which is this page's actual claim.

          .accent-6 rather than the page's orange eyebrow accent: the art
          draws in --accent / --accent-alt and sits on the blue→violet
          panel, where orange would fight the ground it is on. */}
      <div className="accent-6 flex animate-fade-in justify-center" style={{ animationDelay: '180ms' }}>
        <SetupArt className="h-auto w-full max-w-md" />
      </div>
    </div>
  </HeroCanvas>
);

export default PricingHero;
